import { useLanguage } from "../../../../stores/LanguageStore";
import {
  ActionIcon,
  Button,
  Checkbox,
  Group,
  Stack,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconArrowLeft,
  IconArrowRight,
  IconPlus,
  IconX,
} from "@tabler/icons-react";
import PasswordField from "../../../../components/View/PasswordField";
let id = 1;

const OvhStep3 = ({ setActiveStep, domain, emails, setEmails, buyDomain }) => {
  const lang = useLanguage((s) => s.language);
  const changeEmail = ({
    id,
    prefix,
    password,
    display_name,
    error,
    warmup,
  }) => {
    setEmails((prev) =>
      prev.map((x) => ({
        ...x,
        prefix: id === x.id && prefix ? prefix : x.prefix,
        password: id === x.id && password ? password : x.password,
        display_name:
          id === x.id && display_name ? display_name : x.display_name,
        error: id === x.id && error !== undefined ? error : x.error,
        warmup: id === x.id && warmup !== undefined ? warmup : x.warmup,
      }))
    );
  };
  const addEmail = () => {
    setEmails((prev) => [...prev, { prefix: "", id: id++ }]);
  };

  const removeEmail = (id) => {
    setEmails((prev) => {
      return prev.filter((x) => x.id !== id);
    });
  };

  const handleNext = (e) => {
    e.preventDefault();

    setActiveStep(3);
  };

  const handlePrev = () => {
    setActiveStep(1);
  };

  return (
    <Stack component={"form"} onSubmit={handleNext} mih={455}>
      <Title order={2}>
        {lang.ovh.step3.title} <br />
        <span style={{ color: "var(--mantine-color-primary-6)" }}>
          {domain}
        </span>
      </Title>
      <Text size="md">{lang.ovh.step3.text}</Text>

      <Stack>
        {emails.map((email, index) => (
          <Group
            key={email.id}
            align="center"
            w={"100%"}
            wrap="nowrap"
            style={{ border: "1px solid #00000016", borderRadius: 8 }}
            p={"sm"}
          >
            <Stack flex={1}>
              <TextInput
                label={index === 0 ? "Email" : null}
                placeholder="Email"
                value={email.prefix}
                onChange={(e) =>
                  changeEmail({ id: email.id, prefix: e.target.value })
                }
                name="prefix"
                size="md"
                pattern="[^@]*"
                title={lang.ovh.step3["no_@"]}
                rightSection={
                  <Text
                    mx={16}
                    size="lg"
                    c={"black"}
                    bg={"#00000006"}
                    py={4}
                    px={12}
                    style={{ borderRadius: 8 }}
                  >
                    @{domain}
                  </Text>
                }
                rightSectionWidth={"auto"}
                required
              />
              <Group w={"100%"}>
                <TextInput
                  label={lang.ovh.step3.sender}
                  placeholder="John Doe"
                  value={email.display_name}
                  onChange={(e) =>
                    changeEmail({ id: email.id, display_name: e.target.value })
                  }
                  size="md"
                  flex={1}
                  required
                  name={"display_names"}
                />
                <PasswordField
                  label={lang.ovh.step3.password}
                  placeholder={lang.ovh.step3.password_placeholder}
                  defaultValue={email.password}
                  additionalOnchange={(v) =>
                    changeEmail({ id: email.id, password: v })
                  }
                  error={email.error}
                  setError={(v) => changeEmail({ id: email.id, error: v })}
                  size={"md"}
                  wrapperProps={{ flex: 1 }}
                />
              </Group>
              <Checkbox
                label={lang.ovh.step3.activate_warmup}
                checked={email.warmup}
                onChange={(e) =>
                  changeEmail({ id: email.id, warmup: e.target.checked })
                }
                size="md"
              />
            </Stack>
            <Tooltip label={lang.model_emails.bat.dialog.delete_item}>
              <ActionIcon
                size={42}
                color="red"
                variant="light"
                onClick={() => removeEmail(email.id)}
              >
                <IconX size={20} />
              </ActionIcon>
            </Tooltip>
          </Group>
        ))}
        <Button
          variant="light"
          onClick={addEmail}
          size="lg"
          leftSection={<IconPlus />}
        >
          {lang.ovh.step3.add_email}
        </Button>
      </Stack>

      <Group mt={"auto"} justify="space-between" gap={32}>
        <Button
          leftSection={<IconArrowLeft />}
          size="md"
          w={150}
          onClick={handlePrev}
          variant="outline"
          type="button"
        >
          {lang.global.back}
        </Button>

        <Button
          rightSection={<IconArrowRight />}
          size="md"
          flex={1}
          type="submit"
          disabled={
            (!buyDomain && !emails.length) ||
            (emails.length && emails.find((x) => x.error))
          }
        >
          {emails.length > 0 ? lang.ovh.step3.buy_emails : lang.global.ignore}
        </Button>
      </Group>
    </Stack>
  );
};

export default OvhStep3;
